export default {
    SET_FILE_INFO: (state, { data }) => {
        state.upload.file = data;
    },
    SET_FILE_RESPONSE: (state, { data }) => {
        state.upload.response = data;
    }
}